export default __webpack_public_path__ + "static/media/tic-tac-toe.83f0d9ca.png";